import orderInstance from '../instance'

const denyOrder = (orderId, reason) => {
  return orderInstance.post('/orders/' + orderId + '/deny', { reason })
}

export default denyOrder
